export const PHONE_NUMBER = /^((\+)33|0)(1|2|3|4|5)\d{8}$/;
export const MOBILE_PHONE_NUMBER = /^((\+)33|0)(6|7|9)\d{8}$/;
export const CODE_POSTAL = /^\d{5}$/;
export const EMAIL_FORMAT =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const ALL_PHONE_NUMBER = /^((\+)33|(\+)33|0)([1-9])\d{8}$/;
export const IMMATRICULATION =
  /^[A-HJ-NP-TV-Z]{2}[\s-]{0,1}[0-9]{3}[\s-]{0,1}[A-HJ-NP-TV-Z]{2}$|^[0-9]{2,4}[\s-]{0,1}[A-Z]{1,3}[\s-]{0,1}[0-9]{2}$/;
